import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Confirm from "./Confirm";
import { useBmapi } from "../utils/bmapi-context";
import { getErrorMessageString } from "../utils/errors";

export default function CampaignEventStop({
  campaign,
  event,
  open,
  onSuccess,
  onCancel,
}) {
  const {
    bmapi,
    notifyError,
    notifySuccess,
    startLoading,
    stopLoading,
  } = useBmapi();
  const intl = useIntl();

  const handleStop = () => {
    startLoading();

    return bmapi
      .stopBusinessEvent(event.id, event.location_id)
      .then(() => {
        onSuccess();
        notifySuccess(
          intl.formatMessage(
            {
              id: "component.campaignEventStop.successMessage",
              defaultMessage:
                "Hai fermato con successo un evento per la campagna {name}",
            },
            {
              name: campaign.name,
            }
          )
        );
      })
      .catch((e) => notifyError(getErrorMessageString(e, intl)))
      .finally(stopLoading);
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    onCancel();
  };

  return (
    <Confirm
      open={open}
      onConfirm={handleStop}
      onCancel={handleCancel}
      title={campaign.name}
      text={
        <FormattedMessage
          id="component.campaignEventStop.confirm"
          defaultMessage="Sei sicuro di voler fermare un evento per la campagna?"
        />
      }
    />
  );
}
